let allLocaleMessages;

const getLocaleMessages = (propertyName) => {
	if (!propertyName) {
		console.warn('Missing template name');
	}
	try {
		if (!allLocaleMessages) {
			allLocaleMessages = JSON.parse(document.getElementById('localeMessages').innerHTML || {});
		}
		return allLocaleMessages[propertyName] || allLocaleMessages;
	} catch (e) {
		console.warn('Please attach locales to DOM');
		return {}
	}
}

export default getLocaleMessages;



// WEBPACK FOOTER //
// ./buttons/utils/localesMessages.js